// extracted by mini-css-extract-plugin
module.exports = {"tooltipTable":"TooltipTable_tooltipTable__3Ngua","total":"TooltipTable_total__3PybR"};